export enum PageAlertActionTypes {
  SHOW_PAGE_ALERT = "SHOW_PAGE_ALERT",
  HIDE_PAGE_ALERT = "HIDE_PAGE_ALERT",
}
